// extracted by mini-css-extract-plugin
export var collapsedSummary = "_re-0";